import React, { useState } from 'react';
import './FeedbackButton.css';
import { submitFeedback } from '../services/feedbackService';

const FeedbackButton = () => {
  const [showForm, setShowForm] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [feedbackType, setFeedbackType] = useState('general');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!feedback.trim()) return;

    setSubmitting(true);
    try {
      await submitFeedback({
        type: feedbackType,
        message: feedback.trim(),
        rating: null, // Could add star rating later
      });

      setSubmitted(true);
      setFeedback('');
      setTimeout(() => {
        setShowForm(false);
        setSubmitted(false);
        setFeedbackType('general');
      }, 2000);
    } catch (error) {
      console.error('Feedback submission failed:', error);
      alert('Failed to submit feedback. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setShowForm(true)}
        className="feedback-btn"
        title="Share your feedback"
      >
        💬 Feedback
      </button>

      {showForm && (
        <div className="feedback-modal-overlay" onClick={() => setShowForm(false)}>
          <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
            <div className="feedback-header">
              <h3>💬 Share Your Feedback</h3>
              <button
                onClick={() => setShowForm(false)}
                className="feedback-close-btn"
              >
                ×
              </button>
            </div>

            {submitted ? (
              <div className="feedback-success">
                <div className="success-icon">✅</div>
                <h4>Thank you for your feedback!</h4>
                <p>Your input helps us improve RentVibe.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="feedback-form">
                <div className="form-group">
                  <label htmlFor="feedbackType">Feedback Type:</label>
                  <select
                    id="feedbackType"
                    value={feedbackType}
                    onChange={(e) => setFeedbackType(e.target.value)}
                    required
                  >
                    <option value="general">💬 General Feedback</option>
                    <option value="bug">🐛 Bug Report</option>
                    <option value="feature">✨ Feature Request</option>
                    <option value="ui">🎨 UI/UX Suggestion</option>
                    <option value="other">🤔 Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="feedback">Your Feedback:</label>
                  <textarea
                    id="feedback"
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    placeholder="Tell us what you think about RentVibe..."
                    rows="4"
                    maxLength="500"
                    required
                  />
                  <div className="char-count">
                    {feedback.length}/500
                  </div>
                </div>

                <div className="feedback-actions">
                  <button
                    type="button"
                    onClick={() => setShowForm(false)}
                    className="feedback-cancel-btn"
                    disabled={submitting}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="feedback-submit-btn"
                    disabled={submitting || !feedback.trim()}
                  >
                    {submitting ? '📤 Sending...' : '📤 Send Feedback'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FeedbackButton;
